// extracted by mini-css-extract-plugin
export default {"frame-container":"Frame_frame-container__MPEKb","login-hint":"Frame_login-hint__2ulHQ","btnNav_fullspace":"Frame_btnNav_fullspace__-T6e-","btn-nav":"Frame_btn-nav__tGATN"};